<template>
  <v-container>
    <v-row v-if="riepilogo" class="justify-center">
      <v-col cols="12">
        <v-data-table :headers="riepilogo.headers" :items="riepilogo.items" hide-default-footer
          class="elevation-1"></v-data-table>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col v-if="riepilogo" md="2" cols="6">
        <base-material-card color="secondary" icon="mdi-cash" class="text-right">
          <div class="font-weight-light">{{ $t("total") }}</div>
          <div style="font-size: 30px; font-weight: bold">
            {{ riepilogo.totale - selectedPoint / 10 }}
          </div>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row v-if="riepilogo && usePoint && totPoint > 0" class="justify-center">
      <v-slider v-model="selectedPoint" min="0" :step="stepPoint" thumb-label="always" :max="totPoint"
        :label="$t('use_point')">
        <template v-slot:prepend>
          <v-icon color="primary" @click="decrement">mdi-minus</v-icon>
        </template>

        <template v-slot:append>
          <v-icon color="primary" @click="increment">mdi-plus</v-icon>
        </template>
      </v-slider>
    </v-row>
    <v-row class="justify-center">
      <v-card color="transparent" style="margin: 50px; padding: 5px"
        v-bind:style="modPag.pagId === pagId ? selectedPag : null" :v-if="listPag && listPag.length > 0"
        v-for="modPag in listPag" v-bind:key="modPag.pagId">
        <a @click="selectPagamento(modPag)">
          <v-card-title class="justify-center font-weight-light">{{
            modPag.title
          }}</v-card-title>
          <v-card-text>
            <v-layout column align-center justify-center>
              <img class="payLogo" :src="modPag.image" />
            </v-layout>
          </v-card-text>
        </a>
      </v-card>
    </v-row>
    <v-row v-if="dataPag">
      <v-col cols="12" class="text-center">
        <v-layout column align-center justify-center>
          <my-datepicker class="selectDate" v-model="dataPag" :label="$t('payment_date')" required="true" />
        </v-layout>
      </v-col>
    </v-row>
    <v-row v-if="pagId">
      <v-col cols="12" class="text-center">
        <div v-html="istruzioni" v-if="istruzioni" />
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn @click="confirmPagamento" color="success">{{
          $t("confirm_choise")
        }}</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="!listPag || listPag.length === 0" class="justify-center">
      <div>NESSUN METODO DI PAGAMENTO DISPONIBILE</div>
    </v-row>
  </v-container>
</template>

<script>
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "select-mod-pag",
  components: {
    MyDatepicker,
  },
  props: { riepilogo: null, onlyAutoConf: null, usePoint: false, idEvento: null, idProduct: null, tesId: null },
  data() {
    return {
      listPag: null,
      dataPag: null,
      selectedPoint: 0,
      stepPoint: 10,
      totPoint: 0,
      pagId: null,
      istruzioni: null,
      title: null,
      selectedPag: {
        border: "3px solid",
        borderColor: "#4caf50 !important",
      },
    };
  },
  methods: {
    selectPagamento(modPag) {
      this.pagId = modPag.pagId;
      this.title = modPag.title;
      this.istruzioni = modPag.istruzioni;
      if (modPag.dataModificabile === 1)
        this.dataPag = new Date().toISOString().substring(0, 10);
      else this.dataPag = null;
    },
    confirmPagamento() {
      this.$emit("selected", {
        pagId: this.pagId,
        dataPag: this.dataPag,
        title: this.title,
        selectedPoint: this.selectedPoint,
      });
    },
    decrement() {
      this.selectedPoint--;
      if (this.selectedPoint < 0) this.selectedPoint = 0;
    },
    increment() {
      this.selectedPoint++;
      if (this.selectedPoint > totPoint) this.selectedPoint = totPoint;
    },
    loadPoint() {
      let _ = this;
      _.totPoint = 0;
      let totale = 0;
      if (_.riepilogo && _.riepilogo.totale) totale = _.riepilogo.totale;
      let url = "/auth/voucher/getUserPunti/";
      _.chiamataAxios("GET", url).then((response) => {
        _.totPoint = response.data.punti;
        if (_.totPoint > totale * 10) {
          _.totPoint = totale * 10;
        }
        _.totPoint = parseInt(_.totPoint / 10) * 10;
      });
    },
  },
  watch: {
    usePoint: function (newVal) {
      // watch it
      this.loadPoint();
    },
    "riepilogo.totale": function (newVal) {
      // watch it
      this.loadPoint();
    },
  },
  mounted() {
    let _ = this;
    let params = {}
    this.loadPoint();
    let url = "/auth/portal/listMyModPagamento";
    if (_.idEvento) {
      params.idEvento = _.idEvento
    }
    if (_.idProduct) {
      params.idProduct = _.idProduct
    }
    if (_.tesId) {
      params.tesId = _.tesId
    }

    _.listPag = [];
    _.chiamataAxios("POST", url, { body: params }).then((response) => {
      for (let p = 0; p < response.data.length; p++) {
        let pagamento = {
          title: response.data[p].descr,
          pagId: response.data[p].pagId,
          istruzioni: response.data[p].istruzioni,
          dataModificabile: response.data[p].dataModificabile,
          image: response.data[p].logo,
        };
        if (!_.onlyAutoConf || response.data[p].autoConfirmed === 1)
          _.listPag.push(pagamento);
      }
    });
  },
};
</script>
<style scoped>
.payLogo {
  max-height: 50px;
  max-width: 500px;
  width: auto;
  height: auto;
}
</style>